import { useMemo } from "react"
import { FolderOpen } from "lucide-react"
import { DrillDownTable } from "../../widgets"
import { resolveEntityStatus,  } from "../../analytics-engine"
import { getTaskColumns, mapTaskToRow } from "./helpers"
import { DictStatus } from "@pma/types"

export function StatusDrillDownContent({
  tasks,
  statusId,
  statusName,
  statuses,
  translate,
  projectsListRaw,
}: {
  tasks: any[]
  statusId: number
  statusName: string
  statuses: DictStatus[]
  translate: (key: string) => string
  projectsListRaw: any[]
}) {
  const grouped = useMemo(() => {
    const matching = tasks.filter((t) => {
      const display = resolveEntityStatus(t, statuses)
      return statusId ? display.id === statusId : display.name === statusName
    })
    const byProject = new Map<string, any[]>()
    matching.forEach((t) => {
      const row = mapTaskToRow(t, statuses, projectsListRaw)
      const key = row.projectName
      if (!byProject.has(key)) byProject.set(key, [])
      byProject.get(key)!.push(row)
    })
    return byProject
  }, [tasks, statusId, statusName, statuses, projectsListRaw])

  const columns = useMemo(() => getTaskColumns(translate, statuses), [translate, statuses])

  if (!grouped.size)
    return (
      <p className='py-8 text-center text-sm text-muted-foreground'>
        {translate("No tasks found")}
      </p>
    )

  return (
    <div className='flex flex-col gap-6'>
      {Array.from(grouped.entries()).map(([projectName, rows]) => (
        <div key={projectName}>
          <h4 className='mb-2 flex items-center gap-2 text-sm font-semibold text-foreground'>
            <FolderOpen className='h-4 w-4 text-muted-foreground' />
            {projectName}
            <span className='text-xs font-normal text-muted-foreground'>({rows.length})</span>
          </h4>
          <DrillDownTable columns={columns} data={rows} />
        </div>
      ))}
    </div>
  )
}
